/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_New_View_AllInputs */

const vi_whats_new_view_all = /** @type {(inputs: Whats_New_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem tất cả`)
};

/**

* @param {Whats_New_View_AllInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const whats_new_view_all = /** @type {((inputs?: Whats_New_View_AllInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_View_AllInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_whats_new_view_all(inputs)
});